import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPageMedia, type PublicPageMedia, type PageMediaSlot } from "@/lib/page-media.functions";

const PageMediaContext = createContext<PublicPageMedia>({});

export function PageMediaProvider({ children }: { children: ReactNode }) {
  const { data } = useQuery<PublicPageMedia>({
    queryKey: ["page-media"],
    queryFn: () => getPageMedia(),
    staleTime: 5 * 60 * 1000,
  });
  return <PageMediaContext.Provider value={data ?? {}}>{children}</PageMediaContext.Provider>;
}

/** Resolve an image slot, falling back to the bundled defaults. */
export function useMediaSlot(
  key: string,
  fallback: { desktop: string; mobile: string },
): {
  desktop: string;
  mobile: string;
  alt: string | null;
  credit: string | null;
  slot: PageMediaSlot | undefined;
} {
  const media = useContext(PageMediaContext);
  const slot = media[key];
  const desktop = slot?.desktopUrl || fallback.desktop;
  return {
    desktop,
    mobile: slot?.mobileUrl || slot?.desktopUrl || fallback.mobile,
    alt: slot?.alt ?? null,
    credit: slot?.credit?.trim() ? slot.credit.trim() : null,
    slot,
  };
}
